export default __webpack_public_path__ + "media/src/assets/fonts/Bitter-BoldItalic-058def3de2e03e3630c1281512ac8794.ttf";